import { callApi, type AnchorActivityEventPayload } from './callApi'

const frontendSessionID = typeof crypto !== 'undefined' && 'randomUUID' in crypto
  ? crypto.randomUUID()
  : `h5-${Date.now()}-${Math.random().toString(16).slice(2)}`

const sensitiveKeyPattern = /authorization|access_token|refresh_token|rtc_token|token|secret|password|credential|cookie|api_key|apikey/i

export function reportAnchorActivity(payload: AnchorActivityEventPayload) {
  const metadata = sanitizeMetadata(payload.metadata)
  try {
    if (typeof callApi.reportActivityEvent !== 'function') return
    void callApi.reportActivityEvent({
      ...payload,
      frontend_session_id: payload.frontend_session_id || frontendSessionID,
      metadata,
    }).catch(() => undefined)
  } catch {
    // Activity logs are diagnostic only and must never affect call flow.
  }
}

function sanitizeMetadata(metadata?: Record<string, unknown>) {
  if (!metadata) return undefined
  return Object.fromEntries(
    Object.entries(metadata).filter(([key]) => key && !sensitiveKeyPattern.test(key))
  )
}
